<template>
	<div style="padding-bottom: 60px;">
		<!-- 申请入住 -->


		<!-- 单位信息 -->
		<el-form :model="formData" :inline="true" label-width="120px" :rules="rules" ref="formData">
			<p class="titleName">单位信息</p>
			<el-form-item label="所属单位" prop="company">
				<el-autocomplete style="width: 150px;" v-model="formData.company" :fetch-suggestions="querySearchAsync"
					placeholder="请选择所属单位" value-key="unitName" clearable @clear="clearSearch" ref="myAutocomplete">
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="所属部门" prop="department" style="margin-left: -10px;">
				<el-input style="width: 150px;" v-model="formData.department" placeholder="填写部门名称"></el-input>
			</el-form-item>
			<el-form-item label="职务" prop="position">
				<el-input style="width: 150px;" v-model="formData.position" placeholder="请填写职位/职称信息"></el-input>
			</el-form-item>


			<!-- 人才基础信息 -->
			<p class="titleName">基础信息</p>
			<el-form-item label="证件类型" prop="credentialsType">
				<el-select style="width: 150px;" @change="goChoose" v-model="formData.credentialsType" clearable>
					<el-option label="身份证" value="身份证"></el-option>
					<el-option label="护照" value="护照"></el-option>
					<el-option label="港澳台通行证" value="港澳台通行证"></el-option>
					<el-option label="外国人永久居留身份证" value="外国人永久居留身份证"></el-option>
				</el-select>
			</el-form-item>
			<div v-if="sfShow">


				<el-form-item label="上传身份证正面">
					<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile"
						:show-file-list="false" :on-success="handleAvatarSuccess1" :headers="headerData" name="file"
						:before-upload="beforeAvatarUpload">
						<img align="middle" v-if="formData.showCredentialsPath " :src="formData.showCredentialsPath " class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div> -->
					</el-upload>

				</el-form-item>
				<el-form-item label="上传身份证背面">
					<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile"
						:show-file-list="false" :on-success="handleAvatarSuccess2" :headers="headerData" name="file"
						:before-upload="beforeAvatarUpload">
						<img v-if="formData.showApplyPath" :src="formData.showApplyPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<!-- 	<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div> -->
					</el-upload>
				</el-form-item>
				<el-button type="primary" @click="submitZj">提交证件</el-button>
			</div>
			<div>
				<el-form-item label="姓名" prop="name">
					<el-input :disabled="formData.credentialsType=='身份证'" style="width: 150px;" v-model="formData.name"
						placeholder="请填写姓名"></el-input>
				</el-form-item>
				<el-form-item label="出生日期" prop="birthday">
					<el-date-picker :disabled="formData.credentialsType=='身份证'" style="width: 150px;"
					value-format="yyyy-MM-dd"
						v-model="formData.birthday" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>


				<el-form-item label="证件号" prop="idCard" style="margin-left: -15px;">
					<el-input :disabled="formData.credentialsType=='身份证'" style="width: 150px;"
						v-model="formData.idCard" placeholder="请填写证件号" maxlength="18">
					</el-input>
				</el-form-item>
				<el-form-item label="性别" prop="contractPeriod">
					<el-select :disabled="formData.credentialsType=='身份证'" style="width: 150px;"
						v-model="formData.contractPeriod" clearable>
						<el-option value="男" label="男"></el-option>
						<el-option value="女" label="女"></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div>
				<el-form-item prop="marriage" label="婚姻状况">
					<el-select style="width: 150px;" v-model="formData.marriage" placeholder="请选择" clearable="">
						<el-option label="已婚" value="已婚"></el-option>
						<el-option label="未婚" value="未婚"></el-option>
					</el-select>
				</el-form-item>


				<el-form-item label="手机号码" prop="phone" required="">
					<el-input style="width: 150px;" v-model="formData.phone" placeholder="请填写手机号码" maxlength="11">
					</el-input>
				</el-form-item>
				<el-form-item label="人才级别" prop="talentLevel">
					<el-select style="width: 150px;" v-model="formData.talentLevel" placeholder="请填写职位/职称信息" clearable>
						<el-option :value="1" label="本科"></el-option>
						<el-option :value="2" label="硕士"></el-option>
						<el-option :value="3" label="博士"></el-option>
						<!-- <el-option :value="4" label="专家"></el-option> -->
						<!-- <el-option :value="5" label="海归"></el-option> -->
						<el-option :value="5" label="其他"></el-option>
					</el-select>
				</el-form-item>


				<el-form-item label="VIP等级" prop="vip">
					<el-select style="width: 150px;" v-model="formData.vip" clearable>
						<el-option label="VIP1" value="VIP1"></el-option>
						<el-option label="VIP2" value="VIP2"></el-option>
						<el-option label="VIP3" value="VIP3"></el-option>
						<el-option label="VIP4" value="VIP4"></el-option>
						<el-option label="VIP6" value="VIP6"></el-option>
					</el-select>
				</el-form-item>
			</div>

			<div>
				<el-form-item label="喜好" prop="likes">
					<el-input style="width: 500px;" v-model="formData.likes" placeholder="请填写喜好"></el-input>
				</el-form-item>
			</div>
			<div>
				<el-form-item label="备注" prop="remark">
					<el-input type="textarea" v-model="formData.remark" placeholder="请填写备注"></el-input>
				</el-form-item>
			</div>
			<!-- 入住信息 -->
			<!-- <p class="titleName">入住信息</p>
			<div>

				<el-form-item label="入住期限" prop="checkInPeriod">
				
					<el-select v-model="formData.checkInPeriod" placeholder="">
						<el-option label="一年" value="一年"></el-option>
						<el-option label="两年" value="两年"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="房间分配" prop="distributionMode">
					<el-select v-model="formData.distributionMode" placeholder="" @change="changeRegion">
						<el-option label="指定分配" value="指定分配"></el-option>
						<el-option label="授权分配" value="授权分配"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<span v-if="addRoomShow">
						<template v-if="flag">
							<el-cascader v-model="value" :options="options" placeholder="请选择客房" :show-all-levels="false" clearable=""></el-cascader>
						</template>
						<template v-else>
							<span style="margin-left: 20px;">房号: {{formData.bdRoom}}
								&nbsp;&nbsp;</span>
							<el-cascader v-model="value" :options="options" placeholder="请修改客房" :show-all-levels="false" clearable=""></el-cascader>
						</template>


					</span>
				</el-form-item>
			</div>
			<div>
				<el-form-item label="是否有同住人" prop="cohabitFlag">
					<el-select v-model="formData.cohabitFlag" placeholder="">
						<el-option label="是" value="是"></el-option>
						<el-option label="否" value="否"></el-option>
					</el-select>
				</el-form-item>

				<el-button @click="addBdCohabitInformationClick" v-if="formData.cohabitFlag=='是'?true:false">添加同住人</el-button>
			</div>
			<div v-for="(item,index) in formData.bdCohabitInformationList" v-if="formData.cohabitFlag=='是'?true:false">
				<el-form-item label="同住人姓名" :prop="'bdCohabitInformationList.'+index+'.cohabitName'" :rules='[{
						 validator: (rule, value, callback)=>{validateRealName(rule, value, callback)}, 
						trigger: ["change"]
					}]'
				 ref="cohabitName">
					<el-input v-model="item.cohabitName" placeholder="请填写同住人姓名" maxlength="5" @input="cohabitChange"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" :prop="'bdCohabitInformationList.'+index+'.idCard'" :rules='[{
						 validator: (rule, value, callback)=>{checkIdentitytionId(rule, value, callback)}, 
						trigger: ["change"]
					}]'>
					<el-input v-model="item.idCard" placeholder="请填写身份证号" maxlength="18"></el-input>
				</el-form-item>
				<el-form-item label="与入住人关系">
					<el-input v-model="item.relation" placeholder=""></el-input>
				</el-form-item>
				<el-form-item label="联系电话" :prop="'bdCohabitInformationList.'+index+'.phone'" :rules='[{
						 validator: (rule, value, callback)=>{phoneRules(rule, value, callback)}, 
						trigger: ["change"]
					}]'>
					<el-input v-model="item.phone" placeholder="请填写联系电话" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-button @click="deleteBdCohabitClick(index)">删除</el-button>
				</el-form-item>
			</div>

			<div>
				<el-form-item label="入住证明">
					<el-upload action="/api/checkInApply/uploadApply" :on-success="handleAvatarSuccess" name="file" :headers="headerData"
					 :on-remove="removeFile" :before-upload="beforeAvatarUpload" :multiple="false" :on-preview="handlePictureCardPreview"
					 :file-list="formData.showApplyPathList">
						<el-button size="small" type="primary">上传入住证明</el-button>
						<div class="el-upload__tip" slot="tip">请上传申报文件，支持格式JPG、JPEG、PNG、pdf</div>
					</el-upload>
				</el-form-item>
			</div>
			<div>
				<el-form-item label="入住要求">
					<el-input type="textarea" :rows="10" placeholder="请输入入住要求" v-model="formData.checkInRequire" style="width: 400%;">
					</el-input>
				</el-form-item>
			</div> -->
		</el-form>


		<span slot="footer" style="float: right;margin-right: 300px;" class="dialog-footer">
			<el-button @click="cancelClick">取 消</el-button>
			<el-button type="primary" @click="submitApply">确 定</el-button>
		</span>
		<!-- <el-button @click="submitApply" style="margin-left: calc(50% - 49px);margin-top: 30px;" type="success">
			{{submitName}}
		</el-button> -->
	</div>
</template>

<script>
	import downloadFile from '../../../assets/js/downloadFile.js'
	import Carousel from '../../../components/Carousel.vue'
	import birthdayOptions from './birth.js'
	import {
		checkIdentitytionId,
		phoneRules,
		validateRealName,
	} from '../verify.js'



	export default {
		data() {
			return {
				birthdayOptions: [],
				vipBirthday: null,
				// 保证开始时间大于当前时间
				beginDate: {
					disabledDate: (time) => {
						return time <= new Date().getTime();
					}
				},
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				formData: {
					birthday: null,
					likes: null,
					remark: null,
					vip: null,
					birth: null,
					frontPhoto: null,
					backPhoto: null,
					showCredentialsPath: null,
					applyPath: null,
					showApplyPath: null,
					costList: [], //费用列表
					applyFilePathList: [], //申报文件列表
					name: null, //人才名称
					phone: null, //人才电话
					sex: null, //性别
					idCard: null, //身份证号
					talentLevel: null, //人才级别
					credentialsPath: null, //证件文件路径
					applyFilePath: null, //申请材料路径
					company: "", //所属单位
					department: null, //所属部门
					position: null, //职位/职称
					contractPeriod: "", //性别
					credentialsType: "身份证", //证件类型

					credentialsPathList: [], //证件文件路径
					showCredentialsPathList: [], //证件展示路径

					certificateFilePath: null, //企业法人证
					checkInTime: null, //入住日期
					checkInPeriod: "一年", //入住期限
					distributionMode: "授权分配", //分配方式（1.授权分配，2.指定分配）
					cohabitFlag: "否", //是否有同住人（1.是，2.否）
					standardServicesList: [], //标准服务
					checkInRequire: null, //入住要求
					chargePerson: null, //申请负责人
					roomId: "", //住房的id
					marriage: "", //婚姻状况
					bdCohabitInformationList: [], //同住人信息对象集合


				},

				formData2: null,
				flag: null, //判断新增还是编辑
				isAddShow: true, //是否展示房间信息
				customerRoomItem: {}, //房间所有信息
				addRoomShow: null,

				// 请求头携带token
				headerData: {
					Authorization: localStorage.access_token
				},

				rules: {
					company: [{
						required: true,
						message: "所属单位不能为空",
						trigger: ["blur", "change"]
					}],
					department: [{
						required: true,
						message: "部门不能为空",
						trigger: ["blur", "change"]
					}],
					// position: [{
					// 	required: true,
					// 	message: "职位不能为空",
					// 	trigger: ["blur", "change"]
					// }],
					contractPeriod: [{
						required: true,
						message: "职位不能为空",
						trigger: ["blur", "change"],
					}],
					name: [{
						required: true,
						message: "姓名不能为空",
						trigger: ["blur", "change"],
					}, {
						validator: validateRealName,
						trigger: ["blur", "change"]
					}],
					checkInTime: [{
						required: true,
						message: "入住日期不能为空",
						trigger: ["blur", "change"],
					}, ],
					checkInPeriod: [{
						required: true,
						message: "入住期限不能为空",
						trigger: ["blur", "change"],
					}, ],
					distributionMode: [{
						required: true,
						message: "分配方式不能为空",
						trigger: ["blur", "change"],
					}, ],
					// talentLevel: [{
					// 	required: true,
					// 	message: "人才级别不能为空",
					// 	trigger: ["blur", "change"],
					// }],
					birthday: [{
						required: true,
						message: "出生日期不能为空",
						trigger: ["blur", "change"],
					}],
					idCard: [{
							required: true,
							// validator: checkIdentitytionId,
							message: "证件号不能为空",
							trigger: ["blur", "change"],
						},
						// {
						// 
						// 	trigger: ["blur", "change"]
						// },
					],
					phone: [{
						validator: phoneRules,
						trigger: ["blur", "change"]
					}],
					credentialsType: [{
						required: true,
						message: "证件类型不能为空",
						trigger: ["blur", "change"],
					}],
					marriage: [{
						required: "婚姻状态不能为空",
						trigger: ["blur", "change"],
					}]
				},
				options: null, //可选择的房子树
				value: [], //选中的房间、
				roomNumber: null, //房间号
				submitName: "保存", //提交名字
				sfShow: true
			}
		},


		beforeRouteEnter(to, from, next) {
			next(vm => {
				console.log(vm.$route.params);
				vm.formData2 = {
					...vm.formData
				};
				if (sessionStorage.getItem("isAddOrEdit") == "新增") {
					console.log("入住新增");
					vm.flag = true;
					vm.formData = {
						...vm.formData2
					};
					vm.addRoomShow = false;
				} else if (sessionStorage.getItem("isAddOrEdit") == "编辑") {
					console.log("入住编辑");
					vm.flag = false;

					vm.formData = JSON.parse(sessionStorage.getItem("talentFormData"));
					vm.addRoomShow = vm.formData.distributionMode == "指定分配" ? true : false;
					if (vm.formData.approvalStatus == '待审批') {
						vm.submitName = "修 改";
					} else if (vm.formData.approvalStatus == '已审批') {
						vm.submitName = '提 交';
					} else {
						vm.submitName = '保存';
					}

					// if (vm.formData.costList == null) {
					// 	vm.formData.costList = [];
					// }
					// if (vm.formData.standardServicesList == null) {
					// 	vm.formData.standardServicesList = [];
					// }
				}
			});
		},
		mounted() {
			this.birthdayOptions = birthdayOptions
			this.getRoomTree();
		},
		components: {
			Carousel,
		},
		methods: {
			submitZj() {
				this.$http.post("/api/auth/apply", {
					frontPhoto: this.formData.credentialsPath,
					backPhoto: this.formData.applyPath
				}).then(res => {
					console.log(res)
					if(res.data.code=="200"){
						this.formData.name = res.data.data.name
					this.formData.birthday = res.data.data.birthDate.slice(0,4)+'-'+res.data.data.birthDate.slice(4,6)+'-'+res.data.data.birthDate.slice(6,8)
					
					this.formData.idCard = res.data.data.idnumber 
					this.formData.contractPeriod = res.data.data.gender
					this.$message.success('识别成功');
					}else{
						this.$message.error('识别失败，请重新提交');
					}
					
				})
			},
			// 上传成功
			handleAvatarSuccess1(file) {
				console.log(file);
				this.formData.credentialsPath = file.data.filePath;
				this.formData.showCredentialsPath = file.data.showPath;
				console.log(this.formData);
			},
			handleAvatarSuccess2(file) {
				console.log(file);
				this.formData.applyPath = file.data.filePath;
				this.formData.showApplyPath = file.data.showPath;
			},
			// 上传之前
			beforeAvatarUpload(file) {
				console.log(file);
				var isJPG = null;
				if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
					isJPG = true;
				} else {
					isJPG = false;
				}
				// const isLt2M = file.size / 1024 / 1024 < 1;
				if (!isJPG) {
					this.$message.error('上传Logo只能是 JPG/JPEG/PNG 格式!');
				}
				// if (!isLt2M) {
				// 	this.$message.error('上传图片大小不能超过 1MB!');
				// }
				return isJPG;
			},
			goChoose(e) {
				console.log(e)
				if (e == '身份证') {
					this.sfShow = true
				}else{
					this.sfShow=false
				}
			},
			cancelClick() {
				this.$router.go(-1)
			},
			//获取业主的楼栋和楼层以及所属客房
			getRoomTree() {
				let newRoomTree = [];
				this.$http.get("/api/roomManage/getRoomTree").then(res => {
					console.log(res);
					res.data.data.forEach((item1, index1) => {
						newRoomTree.push({
							value: item1.building,
							label: item1.building,
							children: [],
						})
						item1.getStoreyRoomResList.forEach((item2, index2) => {
							newRoomTree[index1].children.push({
								value: item2.storey,
								label: item2.storey,
								children: []
							})
							item2.getRoomResList.forEach((item3, index3) => {
								newRoomTree[index1].children[index2].children.push({
									value: item3.id,
									label: item3.roomNumber,
								})
							})
						})
					})
					this.options = newRoomTree;
				})
			},
			// 添加房子
			addRoom() {
				sessionStorage.setItem("isAddOrEdit", "路由");
			},

			// 添加同住人
			addBdCohabitInformationClick() {
				this.formData.bdCohabitInformationList.push({
					cohabitName: null, //同住人名字
					idCard: null, //身份证
					relation: null, //与入住人关系
					phone: null, //电话	
				})
			},
			// 删除同住人
			deleteBdCohabitClick(index) {
				this.formData.bdCohabitInformationList.splice(index, 1);
				// if (this.formData.bdCohabitInformationList.length == 0) {
				// 	this.formData.cohabitFlag = "否";
				// }
			},
			// 提交申请
			submitApply() {

				console.log("flag", this.flag);
				console.log(this.value);

				console.log(this.formData)

				this.$refs.formData.validate((valid) => {
					if (valid) {

						// 身份证
						// if (this.formData.showCredentialsPathList == null) {
						// 	this.formData.showCredentialsPathList = [];

						// }
						// let files = [];
						// this.formData.showCredentialsPathList.forEach(item => {
						// 	files.push(item.url);
						// })
						// this.formData.showCredentialsPathList = JSON.parse(JSON.stringify(files));
						// if (this.formData.credentialsPathList == null) {
						// 	this.formData.credentialsPathList = [];
						// }
						// let files2 = [];
						// this.formData.credentialsPathList.forEach(item => {
						// 	files2.push(item.url);
						// })
						// this.formData.credentialsPathList = JSON.parse(JSON.stringify(files2));


						// 申报文件
						this.formData.birthday = new Date(this.formData.birthday).getTime()
						// if (this.formData.applyPathList == null) {
						// 	this.formData.applyPathList = [];
						// }
						// let files3 = [];
						// this.formData.applyPathList.forEach(item => {
						// 	files3.push(item.url);
						// })
						// this.formData.applyPathList = JSON.parse(JSON.stringify(files3));
						// if (this.formData.showApplyPathList == null) {
						// 	this.formData.showApplyPathList = [];
						// }
						// let files4 = [];
						// this.formData.showApplyPathList.forEach(item => {
						// 	files4.push(item.url);
						// })
						// this.formData.showApplyPathList = JSON.parse(JSON.stringify(files4));




						// if (this.formData.distributionMode == "指定分配") {
						// 	if (this.value.length == 0 && !this.formData.bdRoom) {
						// 		this.$message.error("请选择客房！！！")
						// 		return;
						// 	}
						// 	this.formData.roomId = this.value[2];
						// }


						// if (this.formData.showCredentialsPathList.length == 0 || this.formData.credentialsPathList.length == 0) {
						// 	this.$message.error("身份证必须要上传或申报文件必须要上传！！！")
						// 	return;
						// }


						// if (this.formData.distributionMode == "指定分配") {
						// 	this.formData.roomId = this.value[2];

						// }
						// console.log(this.value[2]);

						// if (this.formData.distributionMode == "指定分配") {
						// 	this.formData.roomId = this.value[2];

						// }
						// console.log(this.value[2]);

						if (this.flag) {
							this.$http.post("/api/checkInApply/addCheckInApply", {
								...this.formData,
								createdId: null,
							}).then(res => {
								console.log("增加", res);
								this.$message(res.data.message);
								this.$router.push({
									path: "/index/apartment/personnelInformation",
								});
							})
						} else {
							if (this.formData.approvalStatus == '待审批') {
								// if (this.formData.showApplyPathList.length == 0) {
								// 	this.$message.warning("审批时，请上传入住证明");
								// 	return;
								// }
								this.formData.type = 2;
							} else {
								this.formData.type = 1;
							}
							this.$http.post("/api/checkInApply/modifyCheckInApply", {
								...this.formData
							}).then(res => {
								console.log("修改", res);
								this.$message.success(res.data.message);
								this.$router.push({
									path: "/index/apartment/personnelInformation",
								});
							})
						}
					} else {
						return;
					}

				})

			},
			// 分配方式
			changeRegion(val) {
				console.log(val);
				if (val == "指定分配") {
					this.addRoomShow = true;
				} else {
					this.formData.roomId = null;
					this.addRoomShow = false;
				}
			},

			// 查询所有单位信息
			querySearchAsync(queryString, cb) {
				this.$http.get('/api/ownerManage/getOwners?company=' + this.formData.company).then(res => {
					console.log("查询所有单位信息", res);
					let result = res.data.data;
					cb(result);
				})
			},
			// 解决el-autocomplete使用clearable，失效问题
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},

			// 
			cohabitChange(val) {
				console.log(val, this.formData.bdCohabitInformationList);
			},

			// 身份证验证
			checkIdentitytionId(rule, value, callback) {
				if (!value) {
					return callback(new Error("身份证号不能为空"));
				}
				if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
					callback(new Error("你输入的身份证长度或格式错误"));
				}
				//身份证城市
				var aCity = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外"
				};
				if (!aCity[parseInt(value.substr(0, 2))]) {
					callback(new Error("你的身份证地区非法"));
				}
				// 出生日期验证
				var sBirthday = (
						value.substr(6, 4) +
						"-" +
						Number(value.substr(10, 2)) +
						"-" +
						Number(value.substr(12, 2))
					).replace(/-/g, "/"),
					d = new Date(sBirthday);
				if (
					sBirthday !=
					d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
				) {
					callback(new Error("身份证上的出生日期非法"));
				}

				// 身份证号码校验
				var sum = 0,
					weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
					codes = "10X98765432";
				for (var i = 0; i < value.length - 1; i++) {
					sum += value[i] * weights[i];
				}
				var last = codes[sum % 11]; //计算出来的最后一位身份证号码
				if (value[value.length - 1] != last) {
					callback(new Error("你输入的身份证号非法"));
				}
				callback();
			},

			// 手机号验证
			phoneRules(rule, value, callback) {
				if (!value) {
					callback(new Error('请输入联系方式'))
				} else {
					const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
					if (reg.test(value)) {
						callback()
					} else {
						return callback(new Error('请输入正确的电话'))
					}
				}
			},
			// 姓名校验
			validateRealName(rule, value, callback) {
				const realnameReg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
				if (!realnameReg.test(value)) {
					return callback(new Error('姓名格式错误,请输入英文或汉字!'))
				} else {
					callback()
				}
			},

			// handleAvatarSuccess(response, file, fileList) {
			// 	console.log(fileList);
			// 	this.detailFileList(fileList);
			// },

			// // 处理身份证
			// detailFileList(fileList) {
			// 	this.formData.showCredentialsPathList = [];
			// 	// this.formData.credentialsPathList = [];
			// 	fileList.forEach((item) => {
			// 		if (item.hasOwnProperty('response')) {
			// 			this.formData.showCredentialsPathList.push({
			// 				name: item.name,
			// 				url: item.response.data.showPath
			// 			})
			// 			this.formData.credentialsPathList.push({
			// 				name: item.name,
			// 				url: item.response.data.filePath
			// 			});
			// 		} else {
			// 			this.formData.showCredentialsPathList.push({
			// 				name: item.name,
			// 				url: item.url
			// 			});
			// 			// this.formData.credentialsPathList.push(item.url);
			// 		}
			// 	})

			// 	console.log("9999", this.formData.credentialsPathList);
			// },

			// // 删除文件
			// removeFile(file, fileList) {
			// 	console.log(fileList);
			// 	console.log("删除----");
			// 	console.log("ddddd", this.formData.credentialsPathList);
			// 	// console.log(this.formData.showCredentialsPathList);
			// 	var newFileList = [];
			// 	this.formData.credentialsPathList.forEach(item1 => {
			// 		fileList.forEach(item2 => {
			// 			if (item1.name == item2.name) {
			// 				newFileList.push({
			// 					name: item1.name,
			// 					url: item1.url,
			// 				});
			// 			}
			// 		})
			// 	})
			// 	console.log("newFileList", newFileList);
			// 	this.detailFileList(fileList);
			// 	this.formData.credentialsPathList = JSON.parse(JSON.stringify(newFileList));
			// },


			// beforeAvatarUpload(file) {
			// 	var isJPG = null;
			// 	if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
			// 		isJPG = true;
			// 	} else {
			// 		isJPG = false;
			// 	}
			// 	const isLt2M = file.size / 1024 / 1024 < 2;
			// 	if (!isJPG) {
			// 		this.$message.error('上传身份证只能是 JPG/JPEG/PNG 格式!');
			// 	}
			// 	if (!isLt2M) {
			// 		this.$message.error('上传图片大小不能超过 1MB!');
			// 	}
			// 	var uploadFlag = true;
			// 	console.log(this.formData.credentialsPathList);
			// 	if (this.formData.credentialsPathList.length >= 2) {
			// 		uploadFlag = false;
			// 		this.$message.error("上传图片最多为两个，请先删除，在上传")
			// 	}
			// 	return isLt2M && isJPG && uploadFlag;
			// },

			// 输入身份证号码
			// idCardBlur() {
			// 	if ((this.formData.idCard.charAt(16) * 1) % 2) {
			// 		this.formData.contractPeriod = "男";
			// 	} else {
			// 		this.formData.contractPeriod = "女";
			// 	}
			// },



			// 上传申报文件
			handleAvatarSuccess(response, file, fileList) {
				console.log(fileList);
				this.detailFileList(fileList);
			},

			// 上传申报文件
			detailFileList(fileList) {
				this.formData.showApplyPathList = [];
				this.formData.applyPathList = [];
				fileList.forEach((item) => {
					if (item.hasOwnProperty('response')) {
						this.formData.showApplyPathList.push({
							name: item.name,
							url: item.response.data.showPath
						})
						this.formData.applyPathList.push({
							name: item.name,
							url: item.response.data.filePath
						});
					} else {
						this.formData.showApplyPathList.push({
							name: item.name,
							url: item.url
						});
						this.formData.applyPathList.push({
							name: item.name,
							url: item.url
						});
					}
				})
				console.log(this.formData);
			},

			// 删除文件
			removeFile(file, fileList) {
				let newFileList = [];
				let newFileList2 = [];
				this.formData.applyPathList.forEach(item1 => {
					fileList.forEach(item2 => {
						if (item1.url == item2.response.data.filePath) {
							newFileList.push({
								name: item1.name,
								url: item1.url,
							});
						}
					})
				})
				this.formData.showApplyPathList.forEach(item1 => {
					fileList.forEach(item2 => {
						if (item1.url == item2.response.data.showPath) {
							newFileList2.push({
								name: item1.name,
								url: item1.url,
							})
						}
					})
				})
				this.formData.applyPathList = JSON.parse(JSON.stringify(newFileList));
				this.formData.showApplyPathList = JSON.parse(JSON.stringify(newFileList2));
			},
			// 预览
			handlePictureCardPreview(file) {
				window.open(file.url, '_target');
			},

			// 上传文件
			beforeAvatarUpload(file) {
				console.log(file);
				var isJPG = null;
				if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type ===
					'application/pdf') {
					isJPG = true;
				} else {
					isJPG = false;
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传申报文件只能是 JPG/JPEG/PNG/pdf 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 1MB!');
				}
				// var uploadFlag = true;
				// if (this.applyPathList.length >= 2) {
				// 	uploadFlag = false;
				// 	this.$message.error("上传图片最多为两个，请先删除，在上传")
				// }
				return isLt2M && isJPG
			},

		},


	}
</script>

<style scoped="scoped">
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
	}

	.avatar {
		width: 148px;
		height: 148px;
		display: block;
	}

	.return {
		margin: 20px;
	}

	.titleName {
		margin: 20px 0 20px;
		padding-left: 20px;
		font-weight: bold;
	}

	section {
		width: 50%;
		margin: 0 auto;
	}
</style>
